import { Component, OnInit } from '@angular/core';
import { HomePageService } from '../homepage.service';
import { loadStripe } from '@stripe/stripe-js';

@Component({
  selector: 'app-book-appointment',
  templateUrl: './book-appointment.component.html',
  styleUrls: ['./book-appointment.component.css']
})
export class BookAppointmentComponent implements OnInit {
 stripePromise = loadStripe('pk_live_51IYnQ6SIj4AMeFzrfcOglkangxO5D9rQlOEnxLsBAh7tG6YcFsVlXowtSaZLthcbge5Ijwe21ikRI2OM6QLBGXgm00xiwTUeRq');
 // stripePromise = loadStripe('pk_test_51IYnQ6SIj4AMeFzrcpWxIh9Kt0ZgYk49PELOGPveMRR5catu7D7VeRJtcrqtNcaCCukF8J3KWLwjL9AGzJmNIUzq00SwFvnhkp');
 //stripePromise = loadStripe('pk_live_51IYnQ6SIj4AMeFzrfcOglkangxO5D9rQlOEnxLsBAh7tG6YcFsVlXowtSaZLthcbge5Ijwe21ikRI2OM6QLBGXgm00xiwTUeRq');

  bookAppointmentData: any = {};
  emptyFieldError = false;
  servicesList: any[] = [];
  loaderSpinner = false;

  constructor(private homePageService: HomePageService) { }

  ngOnInit(): void {
    this.loaderSpinner = false;
    this.emptyFieldError = false;
    this.listAllServices();
  }

  listAllServices() {
    this.homePageService.servicesList().subscribe((data: any) => {
      this.servicesList = data.serviceList;
    });
  }

  clickFunction() {
    this.emptyFieldError = false;
    if (
      this.bookAppointmentData.name != null &&
      this.bookAppointmentData.name != '' &&
      this.bookAppointmentData.email != null &&
      this.bookAppointmentData.email != '' &&
      this.bookAppointmentData.amount != null &&
      this.bookAppointmentData.amount != '' &&
      this.bookAppointmentData.service != null
    ) {
      this.loaderSpinner = true;
      this.homePageService.getPayment({
        amount: this.bookAppointmentData.amount,
        fullName:this.bookAppointmentData.name,
        email:this.bookAppointmentData.email,
        serviceId:this.bookAppointmentData.service
      }).subscribe((data: any) => {
        this.loaderSpinner = false;
        this.checkout(data.sessionId);
      });
    } else {
      this.emptyFieldError = true;
    }
  }

  async checkout(sessionId){
    const stripe = await this.stripePromise;
    const {error}=await stripe.redirectToCheckout({sessionId:sessionId});
  }

}
